import React, { useState } from "react";
import { Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

/**
 * Collapsed by default. Reveals core plan usage (volume, credits, quotas).
 */
const PlanUsageSection = ({ children }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className={styles.content}>
        <div className={styles.historyHeader}>
          <div>
            <h3 className={styles.header}>
              {t("settings.plan_usage_section_title", "Usage")}
            </h3>
            <p className={styles.historySubtitle}>
              {t(
                "settings.plan_usage_section_hint",
                "Volume, credits, and quotas for your active plan.",
              )}
            </p>
          </div>
          <Button
            type="text"
            icon={expanded ? <UpOutlined /> : <DownOutlined />}
            onClick={() => setExpanded((v) => !v)}
            aria-expanded={expanded}
          >
            {expanded
              ? t("settings.plan_hide_usage", "Hide usage")
              : t("settings.plan_check_usage", "Check usage")}
          </Button>
        </div>
      </div>
      {expanded ? children : null}
    </>
  );
};

export default PlanUsageSection;
